import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { TaskDefinition, TaskDefinitionList } from '../api/models/tasks';

const initialState: TaskDefinitionList = { taskDefinitionList: [] };

export const taskDefinitionSlice = createSlice({
  name: 'taskDefinitionList',
  initialState,
  reducers: {
    setTaskDefinitions: (state, action: PayloadAction<{ taskDefinitions: TaskDefinition[] }>) => {
      state.taskDefinitionList = action.payload.taskDefinitions;
    },
    setInitialTaskDefinitionState: (state) => {
      state.taskDefinitionList = [];
    },
  },
});

export const { setTaskDefinitions, setInitialTaskDefinitionState } = taskDefinitionSlice.actions;

export const selectTaskDefinitions = (state: RootState) => state.taskDefinitionList;

export default taskDefinitionSlice.reducer;
